<template>
  <div style="color:#6c757d !important;">
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <!-- ----------------------------------- -->
        <!-- navbar starts -->
        <vs-navbar
          v-model="indexActive"
          :color="colorx"
          text-color="rgba(255,255,255,.6)"
          active-text-color="rgba(255,255,255,1)"
          class="myNavbar"
        >
          <div slot="title">
            <vs-navbar-title>Graphs Presentations</vs-navbar-title>
          </div>
        </vs-navbar>
        <div class="container-fluid">
          <div class="col-sm-12">
            <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
              <!-- navbar ends -->
              <!-- ----------------------------------- -->
              <!-- container starts -->
              <div class="container mt-5">
                <div class="row">
                  <div class="col-sm-12 p-0 print-scr">
                    <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
                      <i class="material-icons">print</i> Print
                    </span>
                    <vs-breadcrumb
                      align="left"
                      :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Reports-Statistics & Graphs',
                      active: true
                    }
                  ]"
                    ></vs-breadcrumb>
                  </div>
                </div>
              </div>
              <!--  container-bdr -->
              <div class="container mt-2 mb-5">
                <!-- row starts -->
                <div class="row">
                  <!-- col-md starts -->
                  <!--  col-bdr-bottom -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Country</strong>
                          <hr class="line-bordered" />
                          <div class="row">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>

                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedCountry"
                                        :settings="countrySettings"
                                      >
                                        <!-- settings is optional -->
                                        <option value="pakistan" class="text-capitalize">Pakistan</option>
                                      </selectize>
                                    </td>
                                    <td>
                                      <selectize
                                        v-model="selectedOptionCountry"
                                        :settings="itemSettingCountry"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td>
                                      <flat-pickr
                                        class="form-control"
                                        style="background: #fff;font-size:13px;"
                                        placeholder="Start Date"
                                        v-model="dateRangeStartCountry"
                                        :config="dateOptions"
                                      ></flat-pickr>
                                    </td>
                                    <td>
                                      <flat-pickr
                                        class="form-control"
                                        style="background: #fff;font-size:13px;"
                                        placeholder="End Date"
                                        v-model="dateRangeEndCountry"
                                        :config="dateOptions"
                                      ></flat-pickr>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-1" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->

                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Province</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>

                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedProvince"
                                        :settings="provinceSetting"
                                      >
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in provinceArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.title"
                                          class="text-capitalize"
                                        >{{item.title}}</option>
                                      </selectize>
                                    </td>
                                    <td>
                                      <selectize
                                        v-model="provinceTopic"
                                        :settings="topicSettingProvince"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td>
                                      <flat-pickr
                                        class="form-control"
                                        style="background: #fff;font-size:13px;"
                                        placeholder="Start Date"
                                        v-model="startDateProvince"
                                        :config="dateOptions"
                                      ></flat-pickr>
                                    </td>
                                    <td>
                                      <flat-pickr
                                        class="form-control"
                                        style="background: #fff;font-size:13px;"
                                        placeholder="End Date"
                                        v-model="endDateProvince"
                                        :config="dateOptions"
                                      ></flat-pickr>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-2" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->
                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">District</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>
                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize v-model="selectedDist" :settings="distSetting">
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in distArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.title"
                                          class="text-capitalize"
                                        >{{item.title}}</option>
                                      </selectize>
                                    </td>
                                    <td>
                                      <selectize v-model="distTopic" :settings="topicSettingDist">
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateDist"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-3" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->
                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Departments</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>

                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td class="training-width">
                                      <selectize v-model="selectedDept" :settings="deptSetting">
                                        <option
                                          v-for="(item,index) in deptArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.title"
                                          class="text-capitalize"
                                        >{{item.title}}</option>
                                      </selectize>
                                    </td>
                                    <td class="training-width">
                                      <selectize v-model="deptTopic" :settings="topicSettingDept">
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateDept"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- --------------------------------Note-------------------------------- -->
                          <!-- This will be appear when click on any filter -->
                          <div class="col-sm-12 float-right mt-0">
                            <!-- <label for="">By Date</label> -->
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-4" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->
                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Advisor(s)</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>

                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedAdvisor"
                                        :settings="advisorSetting"
                                      >
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in advisorArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.name"
                                        >{{item.name}}</option>
                                      </selectize>
                                    </td>

                                    <td>
                                      <selectize
                                        v-model="advisorTopic"
                                        :settings="topicSettingAdvisor"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateAdvisor"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-5" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->

                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Program Officer(s)</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>
                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedOfficer"
                                        :settings="officerSetting"
                                      >
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in officerArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.name"
                                        >{{item.name}}</option>
                                      </selectize>
                                    </td>

                                    <td>
                                      <selectize
                                        v-model="officerTopic"
                                        :settings="topicSettingOfficer"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateOfficer"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-6" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->

                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Trainer(s)</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>

                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedTrainer"
                                        :settings="trainerSetting"
                                      >
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in trainerArr"
                                          :key="index"
                                          :value="item.id"
                                        >{{item.name}}</option>
                                      </selectize>
                                    </td>

                                    <td>
                                      <selectize
                                        v-model="trainerTopic"
                                        :settings="topicSettingTrainer"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateTrainer"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-7" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->
                  <!-- col-md starts -->
                  <div class="col-md-6 mb-3 pl-0">
                    <div class="grapgh-box">
                      <p class="mt-2 mb-2">
                        <span>
                          <strong class="title">Trainee(s)</strong>
                          <hr class="line-bordered" />
                          <div class="row print-scr">
                            <div class="col-sm-12 mt-0">
                              <strong class="title">Filter By</strong>
                              <table class="table">
                                <tbody class="line-bordered">
                                  <tr class="sm-screen">
                                    <td>
                                      <selectize
                                        v-model="selectedTrainee"
                                        :settings="traineeSetting"
                                      >
                                        <!-- settings is optional -->
                                        <option
                                          v-for="(item,index) in traineeArr"
                                          :key="index"
                                          :value="item.id"
                                        >{{item.name}}</option>
                                      </selectize>
                                    </td>

                                    <td>
                                      <selectize
                                        v-model="traineeTopic"
                                        :settings="topicSettingTrainee"
                                      >
                                        <!-- settings is optional -->
                                        <option value="training">Trainings</option>
                                        <option value="fundingAgency">Funding Agency</option>
                                        <option value="thematicArea">Thematic Area</option>
                                        <option value="project">Project</option>
                                        <option value="subProgram">Subprogram</option>
                                        <option value="department">Department</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                  <tr class="sm-screen">
                                    <td colspan="2">
                                      <selectize
                                        v-model="startDateTrainee"
                                        :settings="startDateSetting"
                                      >
                                        <option
                                          v-for="(item,index) in yearArr"
                                          :key="index"
                                          :value="item.id"
                                          :text="item.value"
                                          class="text-capitalize"
                                        >{{item.value}}</option>
                                      </selectize>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </span>
                      </p>
                      <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
                        <canvas id="bar-chart-grouped-8" width="400" height="400"></canvas>
                      </div>
                    </div>
                  </div>
                  <!-- col-md ends -->
                  <!-- ----------------------------------- -->
                </div>
                <!-- row ends -->
              </div>
              <!-- container ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";
import axios from "axios";
import Chart from "chart.js";
import Selectize from "vue2-selectize";
// flatPickr
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data: () => ({
    isSidebar: false,
    colorx: "#2196f3",
    basepath: process.env.VUE_APP_BASE_PATH,
    indexActive: 0,
    // start country
    selectedCountry: "pakistan",
    selectedOptionCountry: "",
    selected: 1,
    dateRangeStartCountry: [],
    dateRangeEndCountry: [],
    dateOptions: {
      wrap: true,
      dateFormat: "Y-m-d"
    },
    yearOnly: {
      wrap: true,
      dateFormat: "Y"
    },
    yearArr: [],
    countrySettings: {
      placeholder: "Select country",
      delimiter: "|"
    },
    itemSettingCountry: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    // end country

    // start provinces
    selectedProvince: "",
    provinceTopic: "",
    topicSettingProvince: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    startDateProvince: [],
    endDateProvince: [],
    provinceArr: [],
    provinceSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select province here"
    },
    // end provinces

    // start district
    selectedDist: "",
    distTopic: "",
    topicSettingDist: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    startDateSetting: {
      delimiter: "|",
      placeholder: "Select Year"
    },
    startDateDist: "",
    endDateDist: [],
    distArr: [],
    distSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select district here"
    },
    // end district

    // start department
    selectedDept: "",
    deptTopic: "",
    topicSettingDept: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    startDateDept: "",
    deptArr: [],
    deptSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select department here"
    },
    // end department

    // start advisor
    selectedAdvisor: "",
    advisorTopic: "",
    topicSettingAdvisor: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    
    startDateAdvisor: "",
    advisorArr: [],
    advisorSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select advisor here"
    },
    // end advisor

    // start officer
    selectedOfficer: "",
    officerTopic: "",
    topicSettingOfficer: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
   
    startDateOfficer: "",
    officerArr: [],
    officerSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select program officer here"
    },
    // end officer
    // start trainer
    selectedTrainer: "",
    trainerTopic: "",
    topicSettingTrainer: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    startDateTrainer: "",
    trainerArr: [],
    trainerSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select trainer here"
    },
    // end trainer

    // start trainee
    selectedTrainee: "",
    traineeTopic: "",
    topicSettingTrainee: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    
    startDateTrainee: "",
    traineeArr: [],
    traineeSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select trainee here"
    },
    // end trainee

    countryChat: "",
    provinceChat: "",
    dataProvince: [],
    labelProvince: [],
    distChat: "",
    deptChart: "",
    advisorChart: "",
    officerChart: "",
    trainerChart: "",
    traineeChart: ""
  }),
  watch: {
    // country
    selectedOptionCountry() {
      this.showCountryGraph();
    },
    dateRangeStartCountry() {
      this.showCountryGraph();
    },
    dateRangeEndCountry() {
      this.showCountryGraph();
    },
    // --country
    // province
    selectedProvince() {
      this.showProvinceGraph();
    },
    provinceTopic() {
      this.showProvinceGraph();
    },
    startDateProvince() {
      this.showProvinceGraph();
    },
    endDateProvince() {
      this.showProvinceGraph();
    },
    // --province
    // district
    selectedDist() {
      this.showDistGraph();
    },
    distTopic() {
      this.showDistGraph();
    },
    startDateDist() {
      this.showDistGraph();
    },
    // --district
    // department
    selectedDept() {
      this.showDeptGraph();
    },
    deptTopic() {
      this.showDeptGraph();
    },
    startDateDept() {
      this.showDeptGraph();
    },
    // --department
    // advisor
    selectedAdvisor() {
      this.showAdvisorGraph();
    },
    advisorTopic() {
      this.showAdvisorGraph();
    },
    startDateAdvisor() {
      this.showAdvisorGraph();
    },
    // --advisor
    // officer
    selectedOfficer() {
      this.showOfficerGraph();
    },
    officerTopic() {
      this.showOfficerGraph();
    },
    startDateOfficer() {
      this.showOfficerGraph();
    },
    // --officer
    // trainer
    selectedTrainer() {
      this.showTrainerGraph();
    },
    trainerTopic() {
      this.showTrainerGraph();
    },
    startDateTrainer() {
      this.showTrainerGraph();
    },
    // --trainer

    // trainee
    selectedTrainee() {
      this.showTraineeGraph();
    },
    traineeTopic() {
      this.showTraineeGraph();
    },
    startDateTrainee() {
      this.showTraineeGraph();
    }
    // --trainee
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.showCountryGraphOnload();
    this.showProvinceGraphOnload();
    this.showYear();
    this.showDistGraphOnload();
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/programofficer/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.officerArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/advisor/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.advisorArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/report/get/all/trainers"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainerArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/report/get/all/trainees/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.traineeArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    //select all district
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.distArr = response.data;
      });
    //end all district
    // select all depts
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.deptArr = response.data;
      });
    // end all depts
  },
  methods: {
    // this will show country graph onload
    showCountryGraphOnload: function showCountryGraphOnload() {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/reports/country-graph/onload/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.countryChat = new Chart(
            document.getElementById("bar-chart-grouped-1"),
            {
              type: "bar",
              data: {
                labels: [" "],
                datasets: [
                  {
                    label: "No. of Trainings",
                    backgroundColor: "#2ecc71",
                    data: [
                      response.data.kpk.length,
                      response.data.punjab.length,
                      response.data.sindh.length,
                      response.data.baloch.length
                    ]
                  }
                ]
              },
              options: {
                scales: {
                  xAxes: [
                    {
                      type: "category",
                      labels: ["KPK", "Punjab", "Sindh", "Balochistan"]
                    }
                  ],
                  yAxes: [
                    {
                      ticks: {
                        min: 0,
                        max: 100
                      },
                      scaleLabel: {
                        display: true,
                        labelString: "No. of Trainings"
                      }
                    }
                  ]
                }
              }
            }
          );
        });
    },
    //  end of country graph onload
    // this will show province graph onload
    showProvinceGraphOnload: function showProvinceGraphOnload() {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/reports/province-graph/onload/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.dataProvince = [];
          this.labelProvince = [];
          if (response.data) {
            setTimeout(() => {
              response.data.forEach(item => {
                if (item.district.province_id == item.district.province.id) {
                  this.dataProvince.push(item.trngCount);
                  this.labelProvince.push(" " + item.district.title);
                }
              });
              // chart 2 starts
              this.provinceChat = new Chart(
                document.getElementById("bar-chart-grouped-2"),
                {
                  type: "bar",
                  data: {
                    labels: this.labelProvince,
                    datasets: [
                      {
                        label: "No of Trainings",
                        backgroundColor: "#3498db",
                        data: this.dataProvince
                      }
                    ]
                  },
                  options: {
                    scales: {
                      xAxes: [
                        {
                          type: "category"
                          // labels: []
                        }
                      ],
                      yAxes: [
                        {
                          ticks: {
                            min: 0,
                            max: 100,
                            callback: function(value) {
                              return value + " ";
                            }
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "No. of Trainings"
                          }
                        }
                      ]
                    }
                  }
                }
              );
            }, 1000);

            // chart 2 ends
          }
        });
    },
    //  end of province graph onload
    showDistGraphOnload: function showDistGraphOnload() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/reports/district-graph/onload/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.dataDist = [];
          this.labelDist = [];
          if (response.data) {
            setTimeout(() => {
              response.data.forEach(item => {
                if (item.months == 1) {
                  this.dataDist[0] = item.trngCount;
                } else if (item.months == 2) {
                  this.dataDist[1] = item.trngCount;
                } else if (item.months == 3) {
                  this.dataDist[2] = item.trngCount;
                } else if (item.months == 4) {
                  this.dataDist[3] = item.trngCount;
                } else if (item.months == 5) {
                  this.dataDist[4] = item.trngCount;
                } else if (item.months == 6) {
                  this.dataDist[5] = item.trngCount;
                } else if (item.months == 7) {
                  this.dataDist[6] = item.trngCount;
                } else if (item.months == 8) {
                  this.dataDist[7] = item.trngCount;
                } else if (item.months == 9) {
                  this.dataDist[8] = item.trngCount;
                } else if (item.months == 10) {
                  this.dataDist[9] = item.trngCount;
                } else if (item.months == 11) {
                  this.dataDist[10] = item.trngCount;
                } else if (item.months == 12) {
                  this.dataDist[11] = item.trngCount;
                }
              });
              // chart 3 starts
              this.distChat = new Chart(
                document.getElementById("bar-chart-grouped-3"),
                {
                  type: "pie",
                  data: {
                    labels: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "July",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec"
                    ],
                    datasets: [
                      {
                        backgroundColor: [
                          "#f1c40f",
                          "#e74c3c",
                          "#2ecc71",
                          "#3498db",
                          "#95a5a6",
                          "#8e5ea2",
                          "#A7414A",
                          "#A37C27",
                          "#F28A30",
                          "#93A806",
                          "#ABA6BF",
                          "#03353E"
                        ],
                        data: this.dataDist
                      }
                    ]
                  }
                }
              );
              // chart 3 ends
              // chart 4 starts
              this.deptChart = new Chart(
                document.getElementById("bar-chart-grouped-4"),
                {
                  type: "bar",
                  data: {
                    labels: [" "],
                    datasets: [
                      {
                        label: "No of Trainings",
                        backgroundColor: "#A7414A",
                        data: this.dataDist
                      }
                    ]
                  },
                  options: {
                    scales: {
                      xAxes: [
                        {
                          type: "category",
                          labels: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "July",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                          ]
                        }
                      ],
                      yAxes: [
                        {
                          ticks: {
                            min: 0,
                            max: 100,
                            callback: function(value) {
                              return value + " ";
                            }
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "No. of Trainings"
                          }
                        }
                      ]
                    }
                  }
                }
              );
              // chart 4 ends
              // chart 5 starts
              this.advisorChart = new Chart(
                document.getElementById("bar-chart-grouped-5"),
                {
                  type: "bar",
                  data: {
                    labels: [" "],
                    datasets: [
                      {
                        label: "No of Trainings",
                        backgroundColor: "#8e5ea2",
                        data: this.dataDist
                      }
                    ]
                  },
                  options: {
                    scales: {
                      xAxes: [
                        {
                          type: "category",
                          labels: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "July",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                          ]
                        }
                      ],
                      yAxes: [
                        {
                          ticks: {
                            min: 0,
                            max: 100,
                            callback: function(value) {
                              return value + " ";
                            }
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "No. of Trainings"
                          }
                        }
                      ]
                    }
                  }
                }
              );
              // chart 5 ends
              // chart 6 starts
              this.officerChart = new Chart(
                document.getElementById("bar-chart-grouped-6"),
                {
                  type: "line",
                  data: {
                    labels: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec"
                    ],
                    datasets: [
                      {
                        label: "No of trainings",
                        backgroundColor: "#2ecc71",
                        data: this.dataDist
                      }
                    ]
                  },
                  options: {
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            min: 0,
                            max: 10,
                            callback: function(value) {
                              return value + " ";
                            }
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "No. of Trainings"
                          }
                        }
                      ]
                    }
                  }
                }
              );

              // chart 6 ends
              // chart 7 starts
              this.trainerChart = new Chart(
                document.getElementById("bar-chart-grouped-7"),
                {
                  type: "bar",
                  data: {
                    labels: [" "],
                    datasets: [
                      {
                        label: "No of trainings",
                        backgroundColor: "#f1c40f",
                        data: this.dataDist
                      }
                    ]
                  },
                  options: {
                    scales: {
                      xAxes: [
                        {
                          type: "category",
                          labels: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "July",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                          ]
                        }
                      ],
                      yAxes: [
                        {
                          ticks: {
                            min: 0,
                            max: 100,
                            callback: function(value) {
                              return value + " ";
                            }
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "No. of Trainings"
                          }
                        }
                      ]
                    }
                  }
                }
              );
              // chart 7 ends
              // chart 8 starts
              this.traineeChart = new Chart(
                document.getElementById("bar-chart-grouped-8"),
                {
                  type: "pie",
                  data: {
                    labels: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "July",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec"
                    ],
                    datasets: [
                      {
                        backgroundColor: [
                          "#f1c40f",
                          "#e74c3c",
                          "#2ecc71",
                          "#3498db",
                          "#95a5a6",
                          "#8e5ea2",
                          "#A7414A",
                          "#A37C27",
                          "#F28A30",
                          "#93A806",
                          "#ABA6BF",
                          "#03353E"
                        ],
                        data: this.dataDist
                      }
                    ]
                  }
                }
              );
              // chart 8 ends
            }, 1000);
          }
        });
    },

    showCountryGraph: function showCountryGraph() {
      let no_of_training = "";
      if (this.selectedOptionCountry == "training") {
        no_of_training = "No. of Trainings";
      } else if (this.selectedOptionCountry == "fundingAgency") {
        no_of_training = "No. of Funding Agency";
      } else if (this.selectedOptionCountry == "thematicArea") {
        no_of_training = "No. of Thematic Area";
      } else if (this.selectedOptionCountry == "project") {
        no_of_training = "No. of Project";
      } else if (this.selectedOptionCountry == "subProgram") {
        no_of_training = "No. of Sub Program";
      } else if (this.selectedOptionCountry == "department") {
        no_of_training = "No. of Department";
      }
      if (
        this.selectedOptionCountry != "" &&
        this.dateRangeStartCountry != "" &&
        this.dateRangeEndCountry != ""
      ) {
        let kpk = "";
        let punjab = "";
        let sindh = "";
        let baloch = "";
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/country/" +
              this.selectedOptionCountry +
              "/" +
              this.dateRangeStartCountry +
              "/" +
              this.dateRangeEndCountry +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            // chart 1 starts
            kpk = response.data.kpk.length;
            punjab = response.data.punjab.length;
            sindh = response.data.sindh.length;
            baloch = response.data.baloch.length;
            this.countryChat.destroy();
            this.countryChat = new Chart(
              document.getElementById("bar-chart-grouped-1"),
              {
                type: "bar",
                data: {
                  labels: [" "],
                  datasets: [
                    {
                      label: no_of_training,
                      backgroundColor: "#2ecc71",
                      data: [kpk, punjab, sindh, baloch]
                    }
                  ]
                },
                options: {
                  scales: {
                    xAxes: [
                      {
                        type: "category",
                        labels: ["KPK", "Punjab", "Sindh", "Balochistan"]
                      }
                    ],
                    yAxes: [
                      {
                        ticks: {
                          min: 0,
                          max: 100
                        },
                        scaleLabel: {
                          display: true,
                          labelString: no_of_training
                        }
                      }
                    ]
                  }
                }
              }
            );
            // chart 1 ends
          });
      }
    },
    // this will show province chat
    showProvinceGraph: function showProvinceGraph() {
      let no_of_training = "";
      if (this.provinceTopic == "training") {
        no_of_training = "No. of Trainings";
      } else if (this.provinceTopic == "fundingAgency") {
        no_of_training = "No. of Funding Agency";
      } else if (this.provinceTopic == "thematicArea") {
        no_of_training = "No. of Thematic Area";
      } else if (this.provinceTopic == "project") {
        no_of_training = "No. of Project";
      } else if (this.provinceTopic == "subProgram") {
        no_of_training = "No. of Sub Program";
      } else if (this.provinceTopic == "department") {
        no_of_training = "No. of Department";
      }
      if (
        this.selectedProvince != "" &&
        this.provinceTopic != "" &&
        this.startDateProvince != "" &&
        this.endDateProvince != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/province/" +
              this.selectedProvince +
              "/" +
              this.provinceTopic +
              "/" +
              this.startDateProvince +
              "/" +
              this.endDateProvince +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataProvince = [];
            this.labelProvince = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.district.province_id) {
                    this.dataProvince.push(item.trngCount);
                    this.labelProvince.push(" " + item.district.title);
                  }
                });
                // chart 2 starts
                this.provinceChat.destroy();
                this.provinceChat = new Chart(
                  document.getElementById("bar-chart-grouped-2"),
                  {
                    type: "bar",
                    data: {
                      labels: this.labelProvince,
                      datasets: [
                        {
                          label: no_of_training,
                          backgroundColor: "#3498db",
                          data: this.dataProvince
                        }
                      ]
                    },
                    options: {
                      scales: {
                        xAxes: [
                          {
                            type: "category"
                            // labels: []
                          }
                        ],
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 100,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: no_of_training
                            }
                          }
                        ]
                      }
                    }
                  }
                );
              }, 500);

              // chart 2 ends
            }
          });
      }
    },
    // this will show district chart
    showDistGraph: function showDistGraph() {
      if (
        this.selectedDist != "" &&
        this.distTopic != "" &&
        this.startDateDist != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/district/" +
              this.selectedDist +
              "/" +
              this.distTopic +
              "/" +
              this.startDateDist +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataDist = [];
            this.labelDist = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataDist[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataDist[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataDist[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataDist[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataDist[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataDist[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataDist[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataDist[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataDist[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataDist[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataDist[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataDist[11] = item.trngCount;
                  }
                });
                // chart 3 starts
                this.distChat.destroy();
                this.distChat = new Chart(
                  document.getElementById("bar-chart-grouped-3"),
                  {
                    type: "pie",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "July",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          backgroundColor: [
                            "#f1c40f",
                            "#e74c3c",
                            "#2ecc71",
                            "#3498db",
                            "#95a5a6",
                            "#8e5ea2",
                            "#A7414A",
                            "#A37C27",
                            "#F28A30",
                            "#93A806",
                            "#ABA6BF",
                            "#03353E"
                          ],
                          data: this.dataDist
                        }
                      ]
                    }
                  }
                );
                // chart 3 ends
              }, 1000);
            }
          });
      }
    },

    // this will show dept graph on filter
    showDeptGraph: function showDeptGraph() {
      if (
        this.selectedDept != "" &&
        this.deptTopic != "" &&
        this.startDateDept != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/department/" +
              this.selectedDept +
              "/" +
              this.deptTopic +
              "/" +
              this.startDateDept +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataDept = [];
            this.labelDept = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataDept[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataDept[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataDept[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataDept[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataDept[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataDept[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataDept[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataDept[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataDept[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataDept[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataDept[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataDept[11] = item.trngCount;
                  }
                });

                // chart 4 starts
                this.deptChart.destroy();
                this.deptChart = new Chart(
                  document.getElementById("bar-chart-grouped-4"),
                  {
                    type: "bar",
                    data: {
                      labels: [" "],
                      datasets: [
                        {
                          label: this.deptTopic,
                          backgroundColor: "#A7414A",
                          data: this.dataDept
                        }
                      ]
                    },
                    options: {
                      scales: {
                        xAxes: [
                          {
                            type: "category",
                            labels: [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "July",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec"
                            ]
                          }
                        ],
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 100,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: this.deptTopic
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 4 ends
              });
            }
          });
      }
    },
    // this will show advisor graph on filter
    showAdvisorGraph: function showAdvisorGraph() {
      if (
        this.selectedAdvisor != "" &&
        this.advisorTopic != "" &&
        this.startDateAdvisor != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/advisor/" +
              this.selectedAdvisor +
              "/" +
              this.advisorTopic +
              "/" +
              this.startDateAdvisor +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataAdvisor = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataAdvisor[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataAdvisor[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataAdvisor[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataAdvisor[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataAdvisor[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataAdvisor[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataAdvisor[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataAdvisor[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataAdvisor[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataAdvisor[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataAdvisor[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataAdvisor[11] = item.trngCount;
                  }
                });

                // chart 5 starts
                this.advisorChart.destroy();
                this.advisorChart = new Chart(
                  document.getElementById("bar-chart-grouped-5"),
                  {
                    type: "bar",
                    data: {
                      labels: [" "],
                      datasets: [
                        {
                          label: this.advisorTopic,
                          backgroundColor: "#A7414A",
                          data: this.dataAdvisor
                        }
                      ]
                    },
                    options: {
                      scales: {
                        xAxes: [
                          {
                            type: "category",
                            labels: [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "July",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec"
                            ]
                          }
                        ],
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 100,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: this.advisorTopic
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 5 ends
              });
            }
          });
      }
    },

    // this will show officer graph on filter
    showOfficerGraph: function showOfficerGraph() {
      if (
        this.selectedOfficer != "" &&
        this.officerTopic != "" &&
        this.startDateOfficer != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/officer/" +
              this.selectedOfficer +
              "/" +
              this.officerTopic +
              "/" +
              this.startDateOfficer +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataOfficer = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataOfficer[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataOfficer[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataOfficer[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataOfficer[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataOfficer[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataOfficer[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataOfficer[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataOfficer[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataOfficer[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataOfficer[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataOfficer[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataOfficer[11] = item.trngCount;
                  }
                });

                // chart 6 starts
                this.officerChart.destroy();
                this.officerChart = new Chart(
                  document.getElementById("bar-chart-grouped-6"),
                  {
                    type: "line",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          label: this.officerTopic,
                          backgroundColor: "#2ecc71",
                          data: this.dataOfficer
                        }
                      ]
                    },
                    options: {
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 10,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: this.officerTopic
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 6 ends
              });
            }
          });
      }
    },

    // this will show trainer graph on filter
    showTrainerGraph: function showTrainerGraph() {
      if (
        this.selectedTrainer != "" &&
        this.trainerTopic != "" &&
        this.startDateTrainer != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/trainer/" +
              this.selectedTrainer +
              "/" +
              this.trainerTopic +
              "/" +
              this.startDateTrainer +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataTrainer = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataTrainer[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataTrainer[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataTrainer[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataTrainer[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataTrainer[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataTrainer[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataTrainer[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataTrainer[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataTrainer[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataTrainer[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataTrainer[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataTrainer[11] = item.trngCount;
                  }
                });

                /// chart 7 starts
                this.trainerChart.destroy();
                this.trainerChart = new Chart(
                  document.getElementById("bar-chart-grouped-7"),
                  {
                    type: "bar",
                    data: {
                      labels: [" "],
                      datasets: [
                        {
                          label: this.trainerTopic,
                          backgroundColor: "#f1c40f",
                          data: this.dataTrainer
                        }
                      ]
                    },
                    options: {
                      scales: {
                        xAxes: [
                          {
                            type: "category",
                            labels: [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "July",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec"
                            ]
                          }
                        ],
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 100,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: this.trainerTopic
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 7 ends
              });
            }
          });
      }
    },

    // this will show trainer graph on filter
    showTraineeGraph: function showTraineeGraph() {
      if (
        this.selectedTrainee != "" &&
        this.traineeTopic != "" &&
        this.startDateTrainee != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/admin/reports/trainee/" +
              this.selectedTrainee +
              "/" +
              this.traineeTopic +
              "/" +
              this.startDateTrainee +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataTrainee = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach(item => {
                  if (item.months == 1) {
                    this.dataTrainee[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataTrainee[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataTrainee[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataTrainee[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataTrainee[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataTrainee[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataTrainee[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataTrainee[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataTrainee[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataTrainee[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataTrainee[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataTrainee[11] = item.trngCount;
                  }
                });

                // chart 8 starts
                this.traineeChart.destroy();
                this.traineeChart = new Chart(
                  document.getElementById("bar-chart-grouped-8"),
                  {
                    type: "pie",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "July",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          backgroundColor: [
                            "#f1c40f",
                            "#e74c3c",
                            "#2ecc71",
                            "#3498db",
                            "#95a5a6",
                            "#8e5ea2",
                            "#A7414A",
                            "#A37C27",
                            "#F28A30",
                            "#93A806",
                            "#ABA6BF",
                            "#03353E"
                          ],
                          data: this.dataTrainee
                        }
                      ]
                    }
                  }
                );
                // chart 8 ends
              });
            }
          });
      }
    },

    showYear: function showYear() {
      for (var i = 0; i <= 35; i++) {
        this.yearArr.push({ id: 2015 + i, value: 2015 + i });
      }
    },
    // End of province chat
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },

  components: {
    Selectize,
    flatPickr,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}

.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.grapgh-box {
  border: 3px solid #2196f3;
  padding: 10px;
}
.line-bordered {
  border: 0.5px solid #2196f36b;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

strong.title {
  color: #2196f3;
}

tbody.bordered {
  border: 1px solid #2196f3;
}

.selectize-input {
  border: 1px solid #333 !important;
}

table .td {
  border-top: 1px solid #2196f3;
}
@media only screen and (max-width: 600px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
@media only screen and (max-width: 992px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
</style>

<style>
/* .selectize-input{
  border: 1px solid #333 !important;
} */
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>